var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipelineEditPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 21.5172,
    height: 21.5172,
    rx: 2,
    fill: "#22FFD7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.14378C16.0004 8.06482 15.9865 7.98655 15.9592 7.91345C15.9318 7.84035 15.8915 7.77387 15.8405 7.71781L13.5085 5.174C13.4571 5.11839 13.3962 5.0744 13.3291 5.04454C13.2621 5.01469 13.1904 4.99955 13.118 5.00001C13.0456 4.99955 12.9739 5.01469 12.9068 5.04454C12.8398 5.0744 12.7789 5.11839 12.7275 5.174L11.171 6.87187L5.15951 13.4294C5.10853 13.4854 5.06821 13.5519 5.04083 13.625C5.01346 13.6981 4.99959 13.7764 5.00001 13.8553V16.3992C5.00001 16.5583 5.05796 16.7109 5.1611 16.8234C5.26425 16.9359 5.40414 16.9991 5.55001 16.9991H7.882C7.95896 17.0037 8.03595 16.9906 8.10795 16.9606C8.17996 16.9306 8.24539 16.8845 8.3 16.8251L14.2785 10.2676L15.8405 8.59974C15.8907 8.54159 15.9316 8.47467 15.9615 8.40176C15.9668 8.35393 15.9668 8.30559 15.9615 8.25777C15.9641 8.22984 15.9641 8.2017 15.9615 8.17377L16 8.14378ZM7.6565 15.7992H6.10001V14.1013L11.5615 8.14378L13.118 9.84165L7.6565 15.7992ZM13.8935 8.99571L12.337 7.29784L13.118 6.4519L14.669 8.14378L13.8935 8.99571Z",
    fill: "#418A1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineEditPencil);
export default __webpack_public_path__ + "static/media/pipelineEditPencil.91cdefe70ff53788cebd49fe189788e4.svg";
export { ForwardRef as ReactComponent };